import { gql } from '@apollo/client';

export const PAYMENT_FIELDS = gql`
  fragment PaymentFields on Payment {
    referenceId
    note
    paymentAmount
    date
    paymentId
    paymentInvoice
    paymentMadeBy
    paymentReceivedBy
    date
  }
`;
